"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useData = void 0;
var _auth = require("@ori/auth");
var _presentationHttp = require("@ori/presentation-http");
var _contexts = require("../contexts");
var _net = require("../models/graphql-types/net");
var _useGetFeedbackBenefitBanners = require("./useGetFeedbackBenefitBanners");
var _useGetSharingLink = require("./useGetSharingLink");
const useData = () => {
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    headers,
    loading: loadingHeaders
  } = (0, _presentationHttp.useHeaders)();
  const {
    type
  } = (0, _contexts.useFeedbackBenefitDialog)();
  const {
    data,
    loading: loadingBanners
  } = (0, _useGetFeedbackBenefitBanners.useGetFeedbackBenefitBanners)();
  const showCopyLink = type === _net.FeedbackBenefitBannerType.ShareAndEarn && !isAnonymousUser;
  const {
    loading: loadingUrl,
    sharingLink
  } = (0, _useGetSharingLink.useGetSharingLink)();
  const loading = loadingHeaders || loadingBanners && Boolean(headers) || loadingUrl;
  return {
    data,
    link: showCopyLink ? sharingLink : undefined,
    loading
  };
};
exports.useData = useData;
